// assets/localization-links.js
// Gestisce il cambio lingua usando la form di Shopify

document.addEventListener('DOMContentLoaded', function() {
  // Leggi i tag hreflang dall'head per ottenere gli URL tradotti corretti
  const hreflangMap = {};
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => {
    const lang = link.getAttribute('hreflang');
    const url = link.getAttribute('href');
    if (lang && url && lang !== 'x-default') {
      hreflangMap[lang] = url;
    }
  });
  
  // Aggiungi anche l'URL corrente per la lingua attuale
  const currentLang = document.documentElement.lang || 'it';
  hreflangMap[currentLang] = window.location.href;
  
  document.querySelectorAll('.disclosure__item_el').forEach(link => {
    const currentValue = link.dataset.value;
    const langCode = link.getAttribute('hreflang') || link.getAttribute('lang');
    
    // Aggiorna l'href con l'URL tradotto corretto per la SEO
    if (langCode && hreflangMap[langCode]) {
      link.href = hreflangMap[langCode];
    }
    
    // Trova il form e l'input nascosto corrispondente
    const localizationForm = link.closest('localization-form');
    if (!localizationForm) return;
    
    const form = localizationForm.querySelector('form');
    const inputElement = form.querySelector('input[name="language_code"],input[name="country_code"]');
    
    if (!form || !inputElement) return;
    
    // Intercetta il click per usare la logica di Shopify
    link.addEventListener('click', function(event) {
      event.preventDefault();
      inputElement.value = currentValue;
      form.submit();
    });
  });
});
